import {
  AVALIACOES_RESPOSTAS_LIST,
  AVALIACOES_RESPOSTAS_LIST_BY_AVALIACAO,
  AVALIACOES_RESPOSTAS_ADD,
  AVALIACOES_RESPOSTAS_UPSERT,
  AVALIACOES_RESPOSTAS_MODIFY,
  AVALIACOES_RESPOSTAS_REMOVE,
  AVALIACOES_RESULTADOS_LIST
} from '../const/servicesURI';
import requestService from './requestService';
import { httpRequests } from 'investira.sdk';
import utils from '../utils';

const cancel = {
  list: null,
  listByAvaliacao: null,
  listResultados: null
};

export const list = (pParams, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    ...pRequestOptions,
    params: {
      ...pParams
    },
    cancelToken: cancel.list.token
  };

  return requestService(xProps, AVALIACOES_RESPOSTAS_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const listByAvaliacao = (
  pAvaliacaoId,
  pResolve,
  pReject,
  pFinally,
  pRequestOptions = {}
) => {
  if (cancel.listByAvaliacao) {
    cancel.listByAvaliacao.cancel();
  }

  cancel.listByAvaliacao = httpRequests.cancelToken();

  const xProps = {
    ...pRequestOptions,
    cancelToken: cancel.listByAvaliacao.token
  };

  return requestService(xProps, `${AVALIACOES_RESPOSTAS_LIST_BY_AVALIACAO}${pAvaliacaoId}`, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas List By Avaliacao');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const listResultados = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.listResultados) {
    cancel.listResultados.cancel();
  }

  cancel.listResultados = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.listResultados.token
  };

  return requestService(xProps, AVALIACOES_RESULTADOS_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas Resultados List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_RESPOSTAS_ADD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas Add');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const upsert = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xProps = {
    ...pRequestOptions,
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_RESPOSTAS_UPSERT, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas Upsert');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'PATCH'
  };

  return requestService(xProps, AVALIACOES_RESPOSTAS_MODIFY, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas Modify');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'DELETE'
  };

  return requestService(xProps, AVALIACOES_RESPOSTAS_REMOVE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Respostas Remove');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const respostas = {
  list,
  listByAvaliacao,
  listResultados,
  add,
  upsert,
  modify,
  remove,
  cancel
};

export default respostas;
